export default __webpack_public_path__ + "static/lock-b8ce2afbedbcfe98a5294b93401da67b.png";